import { createStore } from 'vuex'
import app from '../app'

import initialState from './initialState';
import persistentStore from './persistentStore';
/* eslint-disable import/no-cycle */
import alerts from './modules/alerts';
import auth from './modules/auth';
import siteMessages from './modules/siteMessages';
import billing from './modules/billing';
import businesses from './modules/businesses';
import businessUsers from './modules/businessUsers';
import cannedReplies from './modules/cannedReplies';
import config from './modules/config';
import contracts from './modules/contracts';
import creatorProgram from './modules/creatorProgram';
import events from './modules/events';
import invoices from './modules/invoices';
import labels from './modules/labels';
import locale from './modules/locale';
import navigation from './modules/navigation';
import packages from './modules/packages';
import payments from './modules/payments';
import pepper from './modules/pepper';
import pins from './modules/pins';
import reports from './modules/reports';
import schedules from './modules/schedules';
import theme from './modules/theme';
import threads from './modules/threads';
import users from './modules/users';
import validation from './modules/validation';
import promotions from './modules/promotions';
import sponsorships from './modules/sponsorships';
import networks from './modules/networks';
import tracking from './modules/tracking';

const options = {
  plugins: [persistentStore.plugin],
  modules: {
    alerts: alerts(initialState.alerts),
    auth: auth(initialState.auth),
    siteMessages: siteMessages(initialState.siteMessages),
    billing: billing(initialState.billing),
    businesses: businesses(initialState.businesses),
    businessUsers: businessUsers(initialState.businessUsers),
    cannedReplies: cannedReplies(initialState.cannedReplies),
    config: config(initialState.config),
    contracts: contracts(initialState.contracts),
    creatorProgram: creatorProgram(initialState.creatorProgram),
    events: events(initialState.events),
    invoices: invoices(initialState.invoices),
    labels: labels(initialState.labels),
    locale: locale(initialState.locale),
    navigation: navigation(initialState.navigation),
    packages: packages(initialState.packages),
    payments: payments(initialState.payments),
    pepper: pepper(initialState.pepper),
    pins: pins(initialState.pins),
    reports: reports(initialState.reports),
    schedules: schedules(initialState.schedules),
    theme: theme(initialState.theme),
    threads: threads(initialState.threads),
    tracking: tracking(initialState.tracking),
    users: users(initialState.users),
    validation: validation(),
    promotions: promotions(initialState.promotions),
    sponsorships: sponsorships(initialState.sponsorships),
    networks: networks(initialState.networks),
  },
};

/**
 * @description Reset stores
 * @param store
 */
export const resetStores = (store) => {
  store.dispatch('alerts/reset');
  store.dispatch('auth/reset');
  store.dispatch('siteMessages/reset');
  store.dispatch('billing/reset');
  store.dispatch('businesses/reset');
  store.dispatch('businessUsers/reset');
  store.dispatch('cannedReplies/reset');
  store.dispatch('config/reset');
  store.dispatch('contracts/reset');
  store.dispatch('creatorProgram/reset');
  store.dispatch('events/reset');
  store.dispatch('invoices/reset');
  store.dispatch('labels/reset');
  store.dispatch('navigation/reset');
  store.dispatch('packages/reset');
  store.dispatch('payments/reset');
  store.dispatch('pepper/reset');
  store.dispatch('pins/reset');
  store.dispatch('reports/reset');
  store.dispatch('schedules/reset');
  store.dispatch('threads/reset');
  store.dispatch('tracking/reset');
  store.dispatch('users/reset');
  store.dispatch('promotions/reset');
  store.dispatch('sponsorships/reset');
  store.dispatch('networks/reset');
};

const store = createStore(options);

// Guard against Vite HMR re-executing this module and installing a fresh store,
// which would replace this.$store in components while leaving the old store
// instance in axios/auth closures — breaking logout and other dispatches.
if (!app.config.globalProperties.$store) {
  app.use(store);
}

export default store
export const useStore = () => store
